// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import constants from "@store/constants";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface FeatureNotesHeaderStyles {}

export const featureNotesHeaderStyles: FeatureNotesHeaderStyles = {};

const styles = featureNotesHeaderStyles;

const FeatureNotesHeader: FC<Props> = ({ id, pageTitle }: Props) => {
    const linkBack = usePageLinkByPageType(constants.pageType.featureNotesList);

    return (
        <OrderHeader title={pageTitle} linkBack={linkBack}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(FeatureNotesHeader),
    definition: {
        group: constants.widgetGroup.featureNotes,
        displayName: "Header",
        allowedContexts: [constants.pageType.featureNotes],
    },
};

export default widgetModule;
